import React from 'react';
import { ArrowUpRight } from 'lucide-react';

import { NEWSROOM_CARD, NEWSROOM_HREF } from '../../constants';

import styles from './styles.module.css';

import { track } from '@/shared/analytics/track';

const NewsroomBand: React.FC = () => (
  <section className={styles.band}>
    <div className={styles.shell}>
      <div className={styles.card}>
        <div>
          <span className={styles.kicker}>{NEWSROOM_CARD.kicker}</span>
          <h2 className={styles.title}>{NEWSROOM_CARD.title}</h2>
          <p className={styles.body}>{NEWSROOM_CARD.body}</p>
        </div>
        <a
          className={styles.cta}
          href={NEWSROOM_HREF}
          onClick={() => track('newsroom_link_clicked')}
          target="_blank"
          rel="noopener noreferrer"
        >
          {NEWSROOM_CARD.ctaLabel}
          <ArrowUpRight size={16} strokeWidth={1.8} aria-hidden="true" />
        </a>
      </div>
    </div>
  </section>
);

export default NewsroomBand;
